import React from 'react';
// import {Link} from 'react-router-dom';
class HeaderNews extends React.Component {

	render(){
		return(
			<div>
				<div className="navbar-top">
	            <div className="nav-wrapper">
	              <div className="side-nav-panel-left">
	                <a href="/" className="side-nav-left2"><i className="fa fa-arrow-left"></i></a>
	              </div>
	              <div className="site-brand">
	                <a href="/"> 
	                  <h3><span className="st2">XPRESS</span><span className="st1">Lite</span></h3>
	                  </a>
	              </div>
	            </div>
                {/* <div className="downloadassets">
					<a href="/assetsDownload"><i className="fa fa-download"></i></a>
				</div> */}
	          </div>
	        </div>
		)
	}

}
export default HeaderNews;


// WEBPACK FOOTER //
// ./src/HeaderNews.js